<template>
  <div class="userManagement-container">
    <!-- <v-header title="面试官维护"></v-header> -->
    <el-container class="container">
      <el-header class="search-form">
        <div class="search-header">查询条件</div>
        <div>
          <label class="title">机构：</label>
          <el-cascader
            v-model="queryParams.organCodes"
            :options="manageComNameOptions"
            :props="cascaderProps"
            :show-all-levels="false"
            clearable
            size="mini"
            placeholder="请选择机构"
          >
          </el-cascader>
        </div>
        <div>
          <label class="title">PE号码：</label>
          <el-input
            size="mini"
            v-model="queryParams.agentCode"
            maxlength="10"
            clearable
            placeholder="请输入PE号码"
          ></el-input>
        </div>
        <div>
          <label class="title">姓名：</label>
          <el-input
            size="mini"
            v-model="queryParams.agentName"
            @input="
              queryParams.agentName = queryParams.agentName.replace(
                /[^a-zA-Z\u4E00-\u9FA5]/g,
                ''
              )
            "
            maxlength="30"
            clearable
            placeholder="请输入姓名"
          ></el-input>
        </div>
        <div>
          <label class="title">状态：</label>
          <el-select
            size="mini"
            v-model="queryParams.enable"
            clearable
            placeholder="请选择状态"
          >
            <el-option
              v-for="(item, index) in stateOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <label class="title">用户角色：</label>
          <el-select
            size="mini"
            v-model="queryParams.agentRoles"
            multiple
            clearable
            placeholder="请选择角色"
          >
            <el-option
              v-for="(item, index) in agentRolesOptions"
              :key="index"
              :label="item.enumName"
              :value="item.enumCode"
            >
            </el-option>
          </el-select>
        </div>
        <div style="float: right">
          <el-button type="primary" size="mini" @click="searchFunc"
            >查询</el-button
          >
          <el-button type="primary" size="mini" @click="exportExcelFunc"
            >导出</el-button
          >
          <el-button type="info" size="mini" @click="resetFunc"
            >重置</el-button
          >
        </div>
      </el-header>
      <div style="margin-top: 10px;padding-left: 20px;">
        <el-button type="primary" size="mini" @click="addFunc"
            >新增</el-button
          >
      </div>
      <el-main class="table-container">
        <el-table
          v-loading="loading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          :data="tableData"
          border
          :cell-style="tableCellStyle"
          :header-cell-style="tableHeaderColor"
          stripe
          style="width: 100%"
          height="100%"
        >
          <el-table-column
            fixed
            align="center"
            type="index"
            label="序号"
            width="50"
          >
          </el-table-column>
          <el-table-column
            fixed
            align="center"
            prop="branchNames"
            width="120"
            show-overflow-tooltip
            label="分公司"
          >
          </el-table-column>
          <el-table-column
            fixed
            align="center"
            prop="orgNames"
            show-overflow-tooltip
            width="150"
            label="T3机构"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="areaNames"
            show-overflow-tooltip
            width="150"
            label="T4机构"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="agentName"
            width="120"
            show-overflow-tooltip
            label="姓名"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="agentCode"
            width="200"
            show-overflow-tooltip
            label="PE号码"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="roles"
            width="150"
            show-overflow-tooltip
            label="用户角色"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="participantsNum"
            width="150"
            show-overflow-tooltip
            label="经手人数"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="enableStatus"
            width="150"
            show-overflow-tooltip
            label="状态"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="timeRange"
            width="180"
            show-overflow-tooltip
            label="时间范围"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="operator"
            width="180"
            show-overflow-tooltip
            label="创建人"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="createDate"
            width="180"
            show-overflow-tooltip
            label="创建时间"
          >
          </el-table-column>
          <el-table-column
            align="center"
            width="180"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="modifyRecordFunc(scope.row)"
                >修改记录</el-button
              >
              <el-button type="text" @click="editRow(scope.row)"
                >修改</el-button
              >
              <el-button type="text" @click="delFunc(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>

      <el-footer>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.pageNum"
          :page-size="20"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-footer>
    </el-container>
    <edit-dialog
      v-if="editDialogVisible"
      :title="editTitle"
      :formData="editFormData"
      :orgList="manageComNameOptions"
      :roleList="agentRolesOptions"
      @close="editDialogVisible = false"
      @refresh="searchFunc"
    />
    <modify-record-dialog
      v-if="modifyRecordDialogVisible"
      :currentData="modifyRecordCurrentData"
      :historyData="modifyRecordHistoryData"
      @close="modifyRecordDialogVisible = false"
    />
  </div>
</template>

<script>
import url from "@/modules/url";
import api from "@/modules/api";
// import vHeader from "@/layout/Header1.vue";
import editDialog from "./component/editDialog.vue";
import modifyRecordDialog from "./component/modifyRecordDialog.vue";
import tableBaseCss from "../tableBaseCss";

export default {
  name: "userManagement",
  components: { editDialog, modifyRecordDialog },
  mixins: [tableBaseCss],
  data() {
    return {
      editFormData: {},
      modifyRecordHistoryData: [],
      modifyRecordCurrentData: [],
      modifyRecordDialogVisible: false,
      editDialogVisible: false,
      show: true, // 区分显示表示数据模块还是显示数据详情模块的变量
      manageComNameOptions: [], // 存储机构下拉菜单数据的集合
      cascaderProps: {
        multiple: true,
        checkStrictly: true,
        value: "code", // 指定 value 字段
        label: "name", // 指定 label 字段
        children: "childList", // 指定 children 字段
      },
      // 存储用户角色下拉菜单数据的集合
      agentRolesOptions: [
        { value: "INTERVIEWER", label: "面试官" },
        { value: "ADMINISTRATOR", label: "机构内勤管理" },
        { value: "ORGAN_HEAD", label: "机构负责人" },
        { value: "BRANCH_OFFICE_REVIEWER", label: "分公司内勤" },
        { value: "HO_MANAGER", label: "总公司管理" },
      ],
      // 存储状态下拉菜单数据的集合
      stateOptions: [
        { value: "", label: "全部" },
        { value: true, label: "启用" },
        { value: false, label: "停用" },
      ],
      token: "", // 设置存储token的变量
      // 定义查询条件的参数对象
      queryParams: {
        organCodes: [], // 机构编码
        agentCode: "", // RE号码
        agentName: "", // 面试官姓名
        enable: "", // 状态
        agentRoles: [], // 用户角色
        pageNum: 1, // 页码数，初始化默认为'1'
        pageSize: 20, // 每页展示的数据条数
        state: null, // 状态,等于空得时候查全部，其他状态值按enable字段的值查询
      },
      tableData: [], // 定义存储表格数据的集合
      total: 0, // 数据总条数
      loading: false, // 定义是否开启表格的加载遮罩的变量
      detailsObj: {},
    };
  },
  created() {
    this.queryParams.enable = this.stateOptions[0].value;
  },
  mounted() {
    this.loading = true;
    this.getCookieData();
    this.getAgentRole();
    this.getManageComNameSelectDataFunc();
    this.getEnumList();
    setTimeout(() => {
      this.queryDataFunc();
    }, 1500);
  },
  methods: {
    //获取coookie中得token数据的方法
    getCookieData() {
      // 先重置清空变量，防止数据有缓存
      this.token = "";
      let arr,
        reg = new RegExp("(^| )" + "jtl" + "=([^;]*)(;|$)"),
        obj = document.cookie.match(reg);
      obj instanceof Array && (arr = obj);
      this.token = arr && unescape(arr[2]);
    },

    // 获取机构下拉菜单数据集合的方法
    getManageComNameSelectDataFunc() {
      api.post(url.getOrgListService, {}, (res) => {
        if (res.result.isSuccess) {
          this.manageComNameOptions = res.data;
          console.log(this.manageComNameOptions, "manageComNameOptions数据");
        } else {
          this.$message({
            type: "error",
            message: res.error,
          });
        }
      });
    },
    // 获取内勤人员角色
    getAgentRole() {
      api.post(url.getAgentRole, { agentCode: "RE2588" }, (res) => {
        if (res.result.isSuccess) {
          console.log(res.data, "获取内勤人员角色");
        } else {
          this.$message({
            type: "error",
            message: res.error,
          });
        }
      });
    },
    // 获取用户角色
    getEnumList() {
      api.post(url.getEnumList, { enumType: "OFFICE_STAFF_ROLE" }, (res) => {
        if (res.result.isSuccess) {
          this.agentRolesOptions = [];
          if (res.data && res.data.length > 0) {
            res.data.forEach((element) => {
              this.agentRolesOptions.push(element);
            });
          }
          console.log(this.agentRolesOptions, "agentRolesOptions数据");
        } else {
          this.$message({
            type: "error",
            message: res.error,
          });
        }
      });
    },
    // 获取列表数据
    queryDataFunc() {
      api.post(url.queryAccountAgentList, this.queryParams, (res) => {
        if (res.result.isSuccess) {
          this.tableData = res.data.rows;
          this.total = ~~res.data.total;
        } else {
          this.$message({
            type: "error",
            message: res.result.error,
          });
        }
        this.loading = false;
      });
    },
    // 新增
    addFunc() {
      this.editTitle = "新增";
      this.editFormData = "";
      this.editDialogVisible = true;
    },
    // 查询
    searchFunc() {
      let pattern = /^[A-Za-z0-9]{1,10}$/;
      if (
        this.queryParams.agentCode &&
        !pattern.test(this.queryParams.agentCode)
      ) {
        this.$message({
          type: "error",
          message: "PE号只能输入字母和数字，且不超过10位",
        });
        return;
      }
      // 点击搜索时，要将页码数重置为1，因为查询的是从第一页开始的数据
      this.queryParams.pageNum = 1;
      console.log(this.queryParams, "列表查询条件");
      if (this.queryParams.enable != "") {
        this.queryParams.state = 1;
      }
      // 调用查询获取表格数据的方法
      this.queryDataFunc();
    },
    // 导出
    exportExcelFunc() {
      if (this.tableData.length != 0) {
        const { organCodes, agentCode, agentName, enable, agentRoles } =
          this.queryParams;
        let options = {
          organCodes: organCodes,
          agentCode: agentCode,
          agentName: agentName,
          enable: enable,
          agentRoles: agentRoles,
          excelTitle: "内勤用户列表",
        };
        api.post(url.exportAgentList, options, (res) => {
          if (res.result.isSuccess) {
            const elink = document.createElement("a");
            elink.download = "内勤用户列表.xlsx";
            // elink.style.display = 'none'
            console.log(this.$downloadUrl + res.data.fileId, "=====");
            elink.href = this.$downloadUrl + res.data.fileId;
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
          } else {
            this.$message({
              type: "error",
              message: res.error,
            });
          }
        });
      } else {
        return false;
      }
    },
    // 重置
    resetFunc() {
      this.queryParams = {
        organCodes: [],
        agentCode: "",
        agentName: "",
        enable: "",
        state: null,
        agentRoles: [],
        pageNum: 1,
        pageSize: 20,
      };
      this.queryDataFunc();
    },

    // 点击修改
    editRow(rowData) {
      this.editTitle = "修改";
      api.post(url.getAccountAgent, { id: rowData.id }, (res) => {
        if (res.result.isSuccess) {
          console.log(res.data, "getAccountAgent============");
          this.editFormData = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.result.error,
          });
        }
      });
      this.editDialogVisible = true;
      console.log(rowData);
    },
    // 修改记录
    modifyRecordFunc(rowData) {
      this.modifyRecordCurrentData = [rowData];
      api.post(
        url.listAccountAgentHistory,
        { agentId: rowData.id + "" },
        (res) => {
          if (res.result.isSuccess) {
            console.log(
              res.data,
              "modifyRecordFunc============",
              typeof res.data
            );
            if (typeof res.data === "object") {
              this.modifyRecordHistoryData = res.data;
            }
          } else {
            this.$message({
              type: "error",
              message: res.result.error,
            });
          }
          // 关闭表格加载遮罩层
          this.loading = false;
        }
      );
      this.modifyRecordDialogVisible = true;
      console.log(rowData);
    },
    // 删除
    delFunc(rowData) {
      let that = this;
      that
        .$confirm("确定要删除该用户吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          api.post(url.deleteAccountAgent, { id: rowData.id }, (res) => {
            if (res.result.isSuccess) {
              console.log(res, "删除");
              this.resetFunc();
            } else {
              if (res.result.errors.length > 0) {
                this.$message({
                  type: "error",
                  message: res.result.errors[0].error,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.result.error,
                });
              }
            }
            // 关闭表格加载遮罩层
            this.loading = false;
          });
        });
    },

    // 切换当前页码
    handleCurrentChange(val) {
      // 切换页码后，将当前的页码数赋值给变量
      this.queryParams.pageNum = val;
      // 调用查询获取表格数据的方法
      this.queryDataFunc();
    },
  },
};
</script>

<style lang="scss" scoped>
.userManagement-container {
  /deep/ .container {
    width: calc(100% - 30px);
    margin: 0 auto;
    margin-top: 15px;
    padding-bottom: 15px;
    background: #ffffff;
    height: calc(100vh - 110px);
    display: flex;
    flex-direction: column;
  }

  .el-header {
    height: auto !important;

    .el-row {
      margin-top: 20px;
    }

    .el-input {
      width: 210px;
    }
  }

  .table-container {
    margin-top: 10px;
    flex: 1;
    overflow: hidden;
    position: relative;
  }
  .el-main {
    flex: 1;
    padding: 0;
    overflow: hidden;
    
    /deep/ .el-table {
      height: 100%;
    }
    
    /deep/ .el-table__body-wrapper {
      overflow-y: auto;
      overflow-x: auto;
    }
    
    /deep/ thead {
      .el-table__cell {
        background: #f5f7fa;
      }
    }
  }

  .el-footer {
    text-align: right;
  }

  button {
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/recruit/userManagement/list.vue